<script setup>
import { defineProps, onMounted  } from "vue";

defineProps({
    stateKey: {
        type: String,
        default: ''
    },
    cartEmptyTxt: {
        type: String,
        default: 'Your cart is empty'
    },
});
onMounted(() => {
})


</script>

<template>
  <div class="shopping-cart-empty">
    <img class="shopping-cart-empty__image lazyload" src="@/assets/images/toshiba/account-empty.png" />
    <div class="shopping-cart-empty__txt">{{ cartEmptyTxt }}</div>
  </div>
</template>